import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { AboutPOICard, AboutPOICardProps } from './AboutPOICard';

/**
 * Props Definition
 */
export interface AboutPOIProps {
    title: string;
    content: string;
    address: string;
    openingHours?: Array<string>;
}

/**
 * Point Of Interests About Container
 */
export const AboutPOI: React.VFC<AboutPOIProps> = ({
    title,
    content,
    address,
    openingHours,
}) => {
    const aboutData: AboutPOICardProps = {
        title: gettext('About the %(title)s', {
            title,
        }),
        content: content,
        address: address,
        openingHours: openingHours,
    };

    return <AboutPOICard {...aboutData} />;
};
